export default{
    "common":{
        "btnPrimary":"Confirm",
        "btnUsual":"Cancel",
        "btnSearch":"Search"
    },
    "header":{
        "nav":"Feature List",
        "who":"System administrator",
        "uimenu" : {
            "userInfo":"Chg Password",
            "loggingstatus":"Logout",
            "version":"Version",
            "typetheme":"Subject Switch",
            "skintitle":"Change the skin",
        },
        "gSearch":{
            "label1":"Settlement",
            "label2":"Assessment",
            "placeholder1":"Fuzzy search of name",
            "placeholder2":"Fuzzy search of code"
        },
        "theme1":"Plain White",
        "theme2":"Dark Night"
    },
    "bookmarks":{
        "usual":"Usual using",
        "stableName":'Controller',
        "collectTip1":"Add",
        "collectTip2":"Del"
    },
    "featurelist":{
        "placeholder":"Please enter the name or abb",
        "tip1":"Bookmarked successfully.",
        "tip2":"Bookmark falied.",
        "tip3":"Unbookmarked successfully.",
        "tip4":"Unbookmark failed."
    },
    "devops":{
        "customer":"Customer：",
        "title":"Please select the customer to be maintained",
        "placeholder":"Enter the search content",
        "label":"Recents:",
        "result":"No matching data found"
    },
    "searchdialog":{
        "title":"Additional Search"
    },
    "personal":{
        "title":"Your Information",
        "name":"Username:",
        "inp1":"Old PWD:",
        "inp2":"New PWD:",
        "inp3":"Verify PWD:",
        "pl1":"Enter the old password",
        "pl2":"Enter the new password",
        "pl3":"Enter the confirm password",
        "valid":"Contained letter and numeric,6-16"
    },
    "leftTree":{
        "dropdown1":"Refresh",
        "dropdown2":"Expand All",
        "dropdown3":"Collapse All",
        "placeholder":"Place enter search content"
    },
    "alarmDialog":{
        "title":"Alarm Info",
        "nosource":"No Data",
        "more":"More",
        "detail":"Detail"
    },
    "guidemask":{
        "step1":"Expand all and add to favorites.",
        "step2":"Expand favorites list and switch navigation.",
        "step3":"Fix navigation bar to view convenient.",
        "step4":"Switch mode and view personal info.",
        "back":"Back",
        "next":"Next",
        "close":"Close"
    },
    "gdmap":{
        "addr":"Address:",
        "lgd":"Longitude:",
        "ltd":"Latitude:",
        "pla":"Please enter location information"
    }
}